import { memo } from "react";
import { WarningTriangle } from "@zenith/assets/icons/components";

export const STATIC_ACCOUNT_DISCLAIMER =
  "Ensure you have verified that the funds have been credited to your account before confirming the sale or releasing the product";

const StaticAccountDisclaimer = memo(function StaticAccountDisclaimer() {
  return (
    <div
      id="static-account-disclaimer"
      className="mt-8 flex items-center gap-4 rounded-xl bg-[#FDF8EE] px-5 py-4"
    >
      <WarningTriangle width={24} height={24} viewBox="0 0 24 24" className="shrink-0" />
      <p className="text-sm text-neutral-900">{STATIC_ACCOUNT_DISCLAIMER}</p>
    </div>
  );
});

export default StaticAccountDisclaimer;
